import type { Phrases } from '../../common/Phrases.d';

import React from 'react';
import { useController, useWatch } from 'react-hook-form';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';
import { ToggleButton } from '/react4xp/components/toggleButton/ToggleButton';
import {
	WHERE_LEGEND_ID,
} from '../../common/constants';
import {
	ANONYMOUS_FIELD_NAME,
	ANONYMOUS_WHERE,
} from '../constants';


export const WhereOtherButton = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const {
		field: {
			onChange,
		},
		fieldState: {
			error,
		},
	} = useController({
		control,
		name: ANONYMOUS_FIELD_NAME.WHERE,
	});
	const whereError = error;
	const where: string = useWatch({ control, name: ANONYMOUS_FIELD_NAME.WHERE}) as string;
	const pressed = where === ANONYMOUS_WHERE.OTHER;
	return (
		<ToggleButton
			aria-labelledby={WHERE_LEGEND_ID}
			error={!!whereError}
			label={phrases['notificationForm.common.whereOtherButton.label']}
			pressed={pressed}
			onClick={() => {
				onChange(pressed ? null : ANONYMOUS_WHERE.OTHER);
			}}
		/>
	);
};
